

//
// ボタンをクリックしたらスクロールして上に戻る
//
function scrollToTop() {
  window.scrollTo({
    top: 0,
    behavior: 'smooth'
  });
}



// 
// ハンバーガーメニュー用のJS
// 
document.addEventListener("DOMContentLoaded", function () {
  const header = document.querySelector("header");
  const toggleButton = document.querySelector(".hamburger");
  const navMenu = document.querySelector("#nav-menu");
  const menuLinks = header.querySelectorAll("a");

  toggleButton.addEventListener("click", function () {
    const isOpen = header.classList.contains("_isOpen");
    toggleButton.setAttribute("aria-expanded", !isOpen);
    header.classList.toggle("_isOpen");

    if (isOpen) {
      document.body.classList.add("no-scroll");
    } else {
      document.body.classList.remove("no-scroll");
    }

  });

  document.addEventListener("click", function (e) {
    if (!navMenu.contains(e.target) && !toggleButton.contains(e.target)) {
      header.classList.remove("_isOpen");
      toggleButton.setAttribute("aria-expanded", "false");
    }
  });

  menuLinks.forEach(link => {
    link.addEventListener("click", function () {
      header.classList.remove("_isOpen");
      toggleButton.setAttribute("aria-expanded", "false");
    });
  });
});


//
// `.mv` にいる時 .header に _visible を付ける
//

document.addEventListener("DOMContentLoaded", function () {
  const header = document.querySelector("header");
  const mvSection = document.querySelector(".mv");

  if (!header || !mvSection) return;

  function toggleHeaderClass() {
    const mvRect = mvSection.getBoundingClientRect();

    // `.mv` が画面内に見えている（上下いずれかが画面内にある）場合
    if (
      mvRect.bottom > 0 &&
      mvRect.top < window.innerHeight
    ) {
      header.classList.add("_visible");
    } else {
      header.classList.remove("_visible");
    }
  }

  // 初回実行とスクロール時に判定
  toggleHeaderClass();
  window.addEventListener("scroll", toggleHeaderClass);
});


// 
// ボタンを押したらクラスを付け替える、複数対応
// 
document.addEventListener('DOMContentLoaded', function () {
  const megaMenuWraps = document.querySelectorAll('._hasMega');

  megaMenuWraps.forEach(function (wrap) {
    const megaMenuBtn = wrap.querySelector('.js-megaMenu');
    const megaMenu = wrap.querySelector('.megaMenu');

    if (megaMenuBtn && megaMenu) {
      megaMenuBtn.addEventListener('click', function () {
        megaMenuBtn.classList.toggle('_isOpen');
        megaMenu.classList.toggle('_isOpen');
      });
    }
  });
});

// =====================================================
// SVGの長さを自動取得してCSS変数に渡す（全SVG対応）
// =====================================================
document.addEventListener("DOMContentLoaded", () => {
  // path, circle, line, polyline に対応
  const svgElements = document.querySelectorAll(
    '.js-svg path, .js-svg circle, .js-svg line, .js-svg polyline'
  );

  svgElements.forEach(el => {
    // getTotalLength() を持つ要素のみ処理
    if (typeof el.getTotalLength === 'function') {
      const length = el.getTotalLength();
      // 要素ごとにCSS変数 --path-length を設定
      el.style.setProperty('--path-length', length);
    }
  });
});

document.addEventListener("DOMContentLoaded", () => {
  const isSP = window.matchMedia("(max-width: 768px)").matches;

  // SP or PC に応じて表示対象を切り替え
  const imgs = document.querySelectorAll(
    isSP
      ? ".mv-imgWrap.pc-none .mv-img"
      : ".mv-imgWrap.sp-none .mv-img"
  );
  const bars = document.querySelectorAll(".mv-progressBar");
  const duration = 6000; // 各スライドの合計時間
  const overlap = 300;   // 次を出すタイミング（ms）
  let current = 0;

  const setActive = (index) => {
    imgs[index].classList.add("_isActive");
    bars[index].classList.add("_isActive");
  };

  const removeActive = (index) => {
    imgs[index].classList.remove("_isActive");
    bars[index].classList.remove("_isActive");
  };

  // 最初の画像を表示
  setActive(current);

  // スライドループ
  setInterval(() => {
    const next = (current + 1) % imgs.length;

    setActive(next);

    setTimeout(() => {
      removeActive(current);
      current = next;
    }, overlap);
  }, duration - overlap);
});


// 
// クリックした画像に切り替える、複数対応、小画像にクラスつける
// 

const setupImageSwitchers = () => {
  const switchers = document.querySelectorAll('.imageSwitcher');
  if (switchers.length === 0) return;

  switchers.forEach(switcher => {
    const bigImg = switcher.querySelector('.bigImg img');
    const smallImgs = switcher.querySelectorAll('.smallImg img');
    if (!bigImg || smallImgs.length === 0) return;

    smallImgs.forEach(img => {
      img.addEventListener('click', () => {
        if (bigImg.src === img.src) return;

        // クラスの切り替え
        smallImgs.forEach(i => i.classList.remove('_display'));
        img.classList.add('_display');

        // トランジションによる画像切り替え
        bigImg.style.opacity = 0;

        const changeImage = () => {
          bigImg.src = img.src;
          bigImg.style.opacity = 1;
        };

        bigImg.addEventListener('transitionend', changeImage, { once: true });
      });
    });
  });
};

setupImageSwitchers();

//
// タブ切り替えのJS　複数対応　他のデータクエリと干渉しない
// 
document.addEventListener("DOMContentLoaded", function () {
  const tabs = document.querySelectorAll(".c-tabs");

  tabs.forEach(tabContainer => {
    const buttons = tabContainer.querySelectorAll(".c-tabs-btn");
    const contents = tabContainer.querySelectorAll(".c-tabs-cont");

    function activateTab(tabId, updateHash = true) {
      buttons.forEach(btn => btn.classList.remove("_active"));
      contents.forEach(content => content.classList.remove("_active"));

      const activeButton = tabContainer.querySelector(`.c-tabs-btn[data-tab="${tabId}"]`);
      const activeContent = tabContainer.querySelector(`#${tabId}`);

      if (activeButton && activeContent) {
        activeButton.classList.add("_active");
        activeContent.classList.add("_active");

        // URLのハッシュを更新（updateHashがtrueの場合のみ）
        if (updateHash) {
          history.pushState(null, "", `#${tabId}`);
        }
      }
    }

    buttons.forEach(button => {
      button.addEventListener("click", () => {
        const tabId = button.dataset.tab;
        activateTab(tabId);
      });
    });

    // **URLのハッシュからタブを開く（tabs を含むIDのみ認識）**
    const hash = window.location.hash.substring(1);
    if (hash && hash.includes("tabs") && document.getElementById(hash)) {
      activateTab(hash, false); // 初回ロード時は履歴を更新しない
    }

    // **ハッシュ変更時にタブを切り替える（tabs を含むIDのみ認識）**
    window.addEventListener("hashchange", () => {
      const newHash = window.location.hash.substring(1);
      if (newHash && newHash.includes("tabs") && document.getElementById(newHash)) {
        activateTab(newHash, false);
      }
    });
  });
});

// 
// スクロールアニメ用
// 
window.addEventListener('DOMContentLoaded', function () {
  new ScrollHint('.js-scrollable', {
    scrollHintIconAppendClass: 'scroll-hint-icon',  // アイコンをWhiteモードに
    i18n: { //テキスト変更
      scrollable: "スクロールできます"
    }
  });
});

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.productsDetail-table figure').forEach(figure => {
    if (figure.querySelector('table')) {
      figure.classList.add('js-scrollable');
    }
  });
});


// Contact Form 7

document.addEventListener('DOMContentLoaded', function () {
  const form = document.querySelector('.wpcf7');
  if (!form) return;

  form.addEventListener('input', function (e) {
    const target = e.target;
    if (target.classList.contains('wpcf7-not-valid')) {
      target.classList.remove('wpcf7-not-valid');

      // 同じ階層または次の要素にあるエラーメッセージを削除
      const errorTip = target.parentNode.querySelector('.wpcf7-not-valid-tip');
      if (errorTip) errorTip.remove();
    }
  });

});


//
// ドロップダウンフィルターの絞り込み処理
//

document.addEventListener('DOMContentLoaded', () => {

  const yearSelect = document.getElementById('filter-year');
  const regionSelect = document.getElementById('filter-region');

  function filterAchievements() {
    const year = yearSelect.value;
    const region = regionSelect.value;

    const activeTab = document.querySelector('.c-tabs-cont._active');
    if (!activeTab) return;

    const tbody = activeTab.querySelector('table tbody');
    if (!tbody) return;

    const rows = tbody.querySelectorAll('tr');
    let visibleCount = 0;

    rows.forEach(row => {
      const yearClass = row.classList[0];   // 例: 2024
      const regionClass = row.classList[1]; // 例: kinki

      const matchYear = !year || year === yearClass;
      const matchRegion = !region || region === regionClass;

      if (matchYear && matchRegion) {
        row.style.display = 'table-row';
        visibleCount++;
      } else {
        row.style.display = 'none';
      }
    });

    // 「該当データなし」表示を制御
    let msg = activeTab.querySelector('.achievements-noData');
    if (!msg) {
      msg = document.createElement('p');
      msg.className = 'achievements-noData';
      msg.textContent = '該当する施工実績はありません。';
      activeTab.appendChild(msg);
    }
    msg.style.display = visibleCount === 0 ? 'block' : 'none';


    /* ---------------------------------------------------
       ★ 追加：フィルタが実行されたら _isOpen をすべて外す
       --------------------------------------------------- */
    const LIMIT_HEIGHT = 800;

    // activeTab の中に限定したいなら activeTab.querySelectorAll にしてもOK
    document.querySelectorAll('.achievements-tableMore._isOpen').forEach(el => {
      el.classList.remove('_isOpen');
      el.style.maxHeight = LIMIT_HEIGHT + 'px';
    });

    document.querySelectorAll('.achievements-moreBtn._isOpen').forEach(btn => {
      btn.classList.remove('_isOpen');
      const label = btn.querySelector('span');
      if (label) label.innerHTML = '続きを見る<i></i>';
    });

  }

  // イベントリスナー登録
  yearSelect.addEventListener('change', filterAchievements);
  regionSelect.addEventListener('change', filterAchievements);

  document.querySelectorAll('.c-tabs-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      setTimeout(filterAchievements, 100); // タブ切替後に発火
    });
  });

});


document.addEventListener('DOMContentLoaded', function () {

  const LIMIT_HEIGHT = 800; // PC 用。SP で変えるならここだけ変更

  // ▼ 開閉状態の同期（ボタンとコンテンツ）
  function syncOpenState(tableContainer) {
    const tableMore = tableContainer.querySelector('.achievements-tableMore');
    const button = tableContainer.querySelector('.achievements-moreBtn');
    if (!tableMore || !button) return;

    const isOpenBtn = button.classList.contains('_isOpen');

    if (isOpenBtn) {
      tableMore.classList.add('_isOpen');
      tableMore.style.maxHeight = tableMore.scrollHeight + 'px';
    } else {
      tableMore.classList.remove('_isOpen');
      tableMore.style.maxHeight = LIMIT_HEIGHT + 'px';
    }
  }

  // ▼ 高さ判定 + ボタン表示/非表示処理
  function updateMoreButtons() {
    document.querySelectorAll('.achievements-table').forEach(tableContainer => {
      const tableMore = tableContainer.querySelector('.achievements-tableMore');
      const button = tableContainer.querySelector('.achievements-moreBtn');
      if (!tableMore || !button) return;

      const isOpen = tableMore.classList.contains('_isOpen');

      // 開いていない時だけ高さをリセット
      if (!isOpen) {
        tableMore.style.maxHeight = LIMIT_HEIGHT + 'px';
      }

      const contentHeight = tableMore.scrollHeight;

      // ボタンの表示/非表示
      if (contentHeight <= LIMIT_HEIGHT) {
        button.style.display = 'none';
      } else {
        button.style.display = '';
      }

      // フィルター後に整合性がズレないよう同期
      syncOpenState(tableContainer);
    });
  }

  // ▼ もっと見る / 閉じるボタンの開閉処理
  document.querySelectorAll('.achievements-moreBtn').forEach(button => {
    button.addEventListener('click', function () {
      const tableContainer = this.closest('.achievements-table');
      const tableMore = tableContainer.querySelector('.achievements-tableMore');
      const label = this.querySelector('span');

      const isOpen = tableMore.classList.contains('_isOpen');

      if (!isOpen) {
        // 開く
        tableMore.classList.add('_isOpen');
        this.classList.add('_isOpen');
        tableMore.style.maxHeight = tableMore.scrollHeight + 'px';
        label.innerHTML = '閉じる<i></i>';
      } else {
        // 閉じる
        tableMore.classList.remove('_isOpen');
        this.classList.remove('_isOpen');
        tableMore.style.maxHeight = LIMIT_HEIGHT + 'px';
        label.innerHTML = '続きを見る<i></i>';
      }
    });
  });

  // ▼ 年度・地域フィルタ時も再判定
  document.getElementById('filter-year').addEventListener('change', updateMoreButtons);
  document.getElementById('filter-region').addEventListener('change', updateMoreButtons);

  // ▼ タブ切り替え時も再判定（遅延でDOM反映後に実行）
  document.querySelectorAll('.c-tabs-btn').forEach(tabBtn => {
    tabBtn.addEventListener('click', () => {
      setTimeout(updateMoreButtons, 10);
    });
  });

  // 初回判定
  updateMoreButtons();
});


//
// ホバーで離れた位置の画像を変える
// 
document.querySelectorAll('.business-wrap').forEach(section => {
  const links = section.querySelectorAll('.business-link[data-key]');
  const imgs = section.querySelectorAll('.business-img[data-key]');

  const showByKey = key => {
    imgs.forEach(img => {
      img.classList.toggle('_isActive', img.dataset.key === key);
    });
  };

  // ホバー時に画像切り替え
  links.forEach(link => {
    const key = link.dataset.key;
    link.addEventListener('mouseenter', () => showByKey(key));
    link.addEventListener('focus', () => showByKey(key)); // アクセシビリティ
  });

  // セクションからマウス離れたら default に戻す
  section.addEventListener('mouseleave', () => showByKey('default'));
});


//
// 事業内容ページ 追従アンカーリンク
//
jQuery(document).ready(function ($) {

  const $anker = $(".ankerLink-follow");
  const $trigger = $(".radiation-protection");

  if ($trigger.length) {
    let triggerTop = $trigger.offset().top;

    const onScroll = () => {
      const scroll = $(window).scrollTop();
      const offset = $(window).width() <= 959 ? 200 : 150;
      if (scroll > triggerTop - offset) {
        $anker.addClass("is-active");
      } else {
        $anker.removeClass("is-active");
      }
    };

    $(window).on("scroll", onScroll);

    // リサイズ時に位置を再計算
    $(window).on("resize", function () {
      triggerTop = $trigger.offset().top;
      onScroll();
    });
  }

  //
  // 対象のセクションに差し掛かった時、対応するaタグにis-activeを付与
  //
  const $links = $(".ankerLink-follow a");
  const sectionIds = $links.map(function () {
    return $(this).attr("href");
  }).get();

  const getSections = () => sectionIds.map((id) => ({
    id,
    top: $(id).offset().top,
  }));

  let sections = getSections();

  // リサイズ時に位置を再計算
  $(window).on("resize", function () {
    sections = getSections();
  });

  // ヘッダーの高さと再スクロール補正関数
  const headerOffset = () => {
    const h1 = $(".js-header:visible").outerHeight() || 0;
    const h2 = $(".ankerLink-follow:visible").outerHeight() || 0;
    const sum = h1 + h2;
    if (sum > 0) return sum;
    return $(window).width() <= 959 ? 200 : 160;
  };

  const forceScrollToHash = (behavior = "instant") => {
    const raw = window.location.hash;
    if (!raw) return;
    const hash = decodeURIComponent(raw);
    const $tgt = $(hash);
    if (!$tgt.length) return;
    const top = Math.max($tgt.offset().top - headerOffset(), 0);
    window.scrollTo({ top, behavior });
  };

  // ページ読み込み後に再補正
  $(window).on("load", function () {
    if (location.hash) {
      forceScrollToHash("instant");
      setTimeout(() => forceScrollToHash("instant"), 300);
    }
  });

  // lazyload対応
  document.addEventListener("lazyloaded", () => {
    if (location.hash) forceScrollToHash("instant");
  }, { passive: true });

  // リサイズ後も再補正
  let _rto;
  $(window).on("resize", function () {
    clearTimeout(_rto);
    _rto = setTimeout(() => {
      sections = getSections();
      if (location.hash) forceScrollToHash("instant");
    }, 150);
  });

  // アンカーリンククリック時のスクロール処理
  $links.off(".offsetScroll").on("click.offsetScroll", function (e) {
    const href = $(this).attr("href");
    if (!href || href.charAt(0) !== "#") return;
    e.preventDefault();
    history.replaceState(null, "", href);
    sections = getSections();
    forceScrollToHash("smooth");
  });

  // ★ 本来のスクロールイベントに header 反映処理だけ追加する
  $(window).on("scroll", function () {
    const windowWidth = $(window).width();
    const offset = windowWidth <= 959 ? 200 : 160;
    const scrollTop = $(this).scrollTop() + offset;

    let currentId = null;
    for (let i = 0; i < sections.length; i++) {
      if (scrollTop >= sections[i].top) {
        currentId = sections[i].id;
      }
    }

    $links.each(function () {
      const href = $(this).attr("href");
      if (href === currentId) {
        $(this).addClass("is-active");
      } else {
        $(this).removeClass("is-active");
      }
    });

    //
    // ★ ここだけ追加：header に is-active を反映
    //
    const hasActive = $links.filter(".is-active").length > 0;
    const $header = $(".js-header");
    if (hasActive) {
      $header.addClass("is-active");
    } else {
      $header.removeClass("is-active");
    }
  });

});


//
// カウントアップランダム
// 
document.addEventListener('DOMContentLoaded', () => {
    const items = document.querySelectorAll('.js-countUp');

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                startCountUp(entry.target);
                observer.unobserve(entry.target);
            }
        });
    });

    items.forEach(item => observer.observe(item));

    function startCountUp(item) {
        const from = parseFloat(item.getAttribute('data-from')) || 0;
        const target = parseFloat(item.getAttribute('data-target')) || 0;
        const duration = parseInt(item.getAttribute('data-duration')) || 2000;
        const decimals = parseInt(item.getAttribute('data-decimal')) || 0;

        let current = from;
        const startTime = performance.now();
        const randomStepMin = 0.1;  // ステップの最小値
        const randomStepMax = 2.5;  // ステップの最大値

        function update() {
            const elapsed = performance.now() - startTime;
            const progress = elapsed / duration;

            // 経過時間に応じて少しずつステップ幅を小さくして滑らかに収束させる
            const randomStep = (Math.random() * (randomStepMax - randomStepMin) + randomStepMin) * (1 - progress);

            current += randomStep;
            if (current >= target || progress >= 1) {
                item.textContent = target.toFixed(decimals);
                return;
            }

            item.textContent = current.toFixed(decimals);
            requestAnimationFrame(update);
        }

        requestAnimationFrame(update);
    }
});


document.addEventListener('DOMContentLoaded', function() {
  const params = new URLSearchParams(window.location.search);
  const target = params.get('scroll');

  if (target) {
    const el = document.getElementById(target);
    if (el) {
      el.scrollIntoView({ behavior: "smooth" });
    }
  }
});


document.addEventListener("DOMContentLoaded", function () {

  const inputs = document.querySelectorAll(
    ".contactForm-wrap .form-post input"
  );

  inputs.forEach(input => {
    input.addEventListener("blur", () => validateNumber(input));
  });

  function validateNumber(input) {
    const value = input.value;
    const isValid = /^[0-9]*$/.test(value); // 数字のみ

    // すでにエラーメッセージがあるか確認
    let errorEl = input.parentElement.querySelector(".error-message");

    if (!isValid && value !== "") {
      // エラー表示
      if (!errorEl) {
        errorEl = document.createElement("span");
        errorEl.classList.add("error-message");
        errorEl.style.color = "red";
        errorEl.style.fontSize = "12px";
        errorEl.style.display = "block";
        errorEl.style.marginTop = "4px";
        input.parentElement.appendChild(errorEl);
      }
      errorEl.textContent = "数字のみ入力できます。";
    } else {
      // 正常（空欄含む）→ エラー消す
      if (errorEl) {
        errorEl.remove();
      }
    }
  }

});
